import Cookies from 'universal-cookie'

export let cookies = new Cookies()

export const setAllCookies = (_cookies) => {
  cookies = new Cookies(_cookies)
}
